import $ from 'jquery' // jQuery

import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言

document.addEventListener('DOMContentLoaded', function (e) {
  const tabs = document.querySelectorAll('[data-tab-target]')
  const tabContents = document.querySelectorAll('[data-tab-content]')

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      const target = document.querySelector(tab.dataset.tabTarget)
      tabContents.forEach((tabContent) => {
        tabContent.classList.remove('active')
      })
      tabs.forEach((tab) => {
        tab.classList.remove('active')
      })
      tab.classList.add('active')
      target.classList.add('active')
    })
  })
})

let officeGal = new Swiper('.office__gal', {
  loop: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'fraction',
    clickable: true,
  },
  slidesPerView: 1.4,
  spaceBetween: 40,
  centeredSlides: true,
  breakpoints: {
    // スライドの表示枚数：767px以上の場合
    767: {
      slidesPerView: 2.5,
      spaceBetween: 100,
    },
  },
})

const btns = document.querySelectorAll('.accordion-title')

// fn
function accordion() {
  // this = the btn | icon & bg changed
  this.classList.toggle('is-open')

  // the acc-content
  const content = this.nextElementSibling

  // IF open, close | else open
  if (content.style.maxHeight) content.style.maxHeight = null
  else content.style.maxHeight = content.scrollHeight + 'px'
}

// event
btns.forEach((el) => el.addEventListener('click', accordion))

if (document.getElementsByClassName('p__under')) {
  pageUnder()
}

function pageUnder() {
  const mvTitleEn = document.querySelector('.js-mv-sub') //←動かしたい要素を指定しています。
  const mvTitle = document.querySelector('.js-mv-ttl') //←動かしたい要素を指定しています。
  const mvText = document.querySelector('.js-mv-text') //←動かしたい要素を指定しています。

  if (document.querySelector('.pageTitle') != null) {
    const pageMV = gsap.timeline({
      scrollTrigger: {
        trigger: '.pageTitle',
        start: 'top bottom-=200',
        end: 'top center',
        markers: false,
      },
    })
    pageMV
      .to(mvTitleEn, { opacity: 1, delay: 0.2, duration: 0.2 })
      .add(() => {
        mvTitle.classList.add('active')
      })
      .to(mvText, { opacity: 1, delay: 1, duration: 0.2, y: 0 })

    //   //  ##  ##     ##  ######             #####   #####    ####
    //   //  ##  ####   ##    ##              ##   ##  ##  ##  ##
    //   //  ##  ##  ## ##    ##    ########  ##   ##  #####    ###
    //   //  ##  ##    ###    ##              ##   ##  ##  ##     ##
    //   //  ##  ##     ##    ##               #####   #####   ####
    window.addEventListener('load', function (e) {
      setTimeout(() => {
        window.intObs('-35% 0px')
      }, 300)
    })
  }
}

$(function () {
  const splitText = $('.splitText')
  if (splitText.length) {
    splitText.each(function () {
      var content = $(this).html(),
        trimText = content.trim(),
        newText = ''

      trimText.split('').forEach(function (e) {
        if (e == ' ') {
          newText += '<span>&nbsp;</span>'
        } else {
          newText += '<span>' + e + '</span>'
        }
      })
      $(this).html(newText)
    })
  }
})

// 背景色が伸びて出現（左から右）

if (document.querySelector('.bgappearTrigger') != null) {
  window.addEventListener('scroll', function () {
    const textFade = document.querySelector('.bgappearTrigger')
    const backgroundFade = document.querySelector('.bgRLextendTrigger')
    const rect2 = backgroundFade.getBoundingClientRect().top
    const scroll = window.scrollY

    const offset2 = rect2 + scroll
    const windowHeight2 = window.innerHeight

    if (scroll > offset2 - windowHeight2) {
      backgroundFade.classList.add('backgroundExtend')
    } else {
      backgroundFade.classList.remove('backgroundExtend')
    }

    const rect1 = textFade.getBoundingClientRect().top
    const offset1 = rect1 + scroll
    const windowHeight = window.innerHeight

    if (scroll > offset1 - windowHeight) {
      textFade.classList.add('textAppear')
    } else {
      textFade.classList.remove('textAppear')
    }
  })
}

if (document.querySelector('.scrollNav') != null) {
  window.addEventListener('scroll', function (e) {
    let documentHeight = document.body.scrollHeight
    let currentScroll = window.scrollY
    let topMV = this.document.querySelector('.topMV')
    let scrollNav = this.document.querySelector('.scrollNav')
    let MVheight = topMV.offsetHeight

    if (currentScroll > MVheight + 85 + 80) {
      scrollNav.classList.add('s')
    } else {
      scrollNav.classList.remove('s')
    }

    // let fixElms = document.querySelectorAll('.scroll__item')
    // let sidebar_p_1 = document.querySelector('.p-1')
    // let sidebar_p_2 = document.querySelector('.p-2')
    // let sidebar_p_3 = document.querySelector('.p-3')
    // let sidebar_p_4 = document.querySelector('.p-4')

    // let part_1 = document.getElementsByClassName('part-1')
    // let part_2 = document.getElementsByClassName('part-2')
    // let part_3 = document.getElementsByClassName('part-3')
    // let part_4 = document.getElementsByClassName('part-4')

    // if (document.querySelector('.part-1')) {
    //   if (currentScroll <= part_1[0].offsetTop) {
    //     fixElms.forEach(function (elm) {
    //       elm.classList.remove('current')
    //     })
    //     sidebar_p_1.classList.add('current')
    //   } else if (part_1[0] && part_2[0].offsetTop < currentScroll && currentScroll <= part_2[0].offsetTop) {
    //     fixElms.forEach(function (elm) {
    //       elm.classList.remove('current')
    //     })
    //     sidebar_p_2.classList.add('current')
    //   } else if (
    //     part_2[0] &&
    //     part_3[0] &&
    //     part_2[0].offsetTop < currentScroll &&
    //     currentScroll <= part_3[0].offsetTop
    //   ) {
    //     fixElms.forEach(function (elm) {
    //       elm.classList.remove('current')
    //     })
    //     sidebar_p_3.classList.add('current')
    //   } else if (
    //     part_3[0] &&
    //     part_4[0] &&
    //     part_3[0].offsetTop < currentScroll &&
    //     currentScroll <= part_4[0].offsetTop
    //   ) {
    //     fixElms.forEach(function (elm) {
    //       elm.classList.remove('current')
    //     })
    //     sidebar_p_4.classList.add('current')
    //   }
    // }
  })
}

// Sticky, Smooth, Active Nav
// let mainNavLinks = document.querySelectorAll('.scrollNav ul li a')
// let mainSections = document.querySelectorAll('.page-value__section')

// window.addEventListener('scroll', (event) => {
//   let topMV = this.document.querySelector('.topMV')
//   let fromTop = window.scrollY

//   mainNavLinks.forEach((link) => {
//     let section = document.querySelector(link.hash)

//     if (section.offsetTop <= fromTop && section.offsetTop + section.offsetHeight > fromTop) {
//       link.classList.add('current')
//     } else {
//       link.classList.remove('current')
//     }
//   })
// })
